import { ISystemOverviewResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export type LocationSystemFilter = Readonly<{
    locationId: string | undefined;
    isFavorite?: boolean;
    isDynamic?: boolean;
}>;

export type LocationSystemDataSourceOptions = BaseDataSourceOptions<
    ISystemOverviewResponse,
    LocationSystemFilter
>;

const queryFn: DataSourceQuery<ISystemOverviewResponse, LocationSystemFilter> = ({
    filter: { locationId, isFavorite, isDynamic },
    sort,
    page,
    pageLimit,
}) => {
    const filter = Filter.and(
        locationId && Filter.eq('LocationId', locationId),
        isFavorite !== undefined ? Filter.eq('IsFavorited', isFavorite) : undefined,
        isDynamic !== undefined
            ? Filter.eq('IsCollectorDependentSystem', isDynamic)
            : undefined,
        Filter.eq('Active', true)
    );

    const orderBy = buildOrderBy(sort);

    return toDataSourceResult(
        sdClient.getSystemsOverview({ filter, page, pageLimit, orderBy })
    );
};

export type LocationSystemPagedDataSource = PagedDataSource<
    ISystemOverviewResponse,
    LocationSystemFilter
>;

export type LocationSystemInfiniteDataSource = InfiniteDataSource<
    ISystemOverviewResponse,
    LocationSystemFilter
>;

export function useLocationSystemsPagedDataSource(
    options: LocationSystemDataSourceOptions
): LocationSystemPagedDataSource {
    return usePagedDataSource({
        ...options,
        query: queryFn,
    });
}

export function useLocationSystemsInfiniteDataSource(
    options: LocationSystemDataSourceOptions
): LocationSystemInfiniteDataSource {
    return useInfiniteDataSource({
        ...options,
        query: queryFn,
    });
}
